import { render, staticRenderFns } from "./AllGamesBanner.vue?vue&type=template&id=06bd670a&scoped=true"
import script from "./AllGamesBanner.vue?vue&type=script&lang=js"
export * from "./AllGamesBanner.vue?vue&type=script&lang=js"
import style0 from "./AllGamesBanner.vue?vue&type=style&index=0&id=06bd670a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd670a",
  null
  
)

export default component.exports